var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewPasswordIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1407 7.5039V5.44058C12.1407 3.30245 10.512 1.66406 8.47414 1.66406C6.43619 1.66406 4.64716 3.30245 4.64716 5.44058L4.54698 7.5039M15.0609 9.16701V7.5039H1.66797L1.66898 18.3321H6.66925",
    stroke: "#1E201C",
    strokeWidth: 1.04167
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4014 15.1705C12.0293 14.8247 11.6146 14.6347 11.0581 14.6347C10.0336 14.6347 9.20312 15.463 9.20312 16.4848C9.20312 17.5065 10.0336 18.3349 11.0581 18.3349C12.0826 18.3349 12.9131 17.5065 12.9131 16.4848C12.9131 16.0181 12.6873 15.496 12.4014 15.1705ZM12.4014 15.1705L14.3855 13.2095M14.3855 13.2095L16.31 11.3073C16.3429 11.2749 16.3959 11.2752 16.4282 11.308L18.3331 13.2413M14.3855 13.2095L15.6885 14.5255",
    stroke: "#1E201C",
    strokeWidth: 1.04167
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewPasswordIcon);
export default __webpack_public_path__ + "static/media/new-password-icon.5a33540f559d1c0027837cfaf7b709fb.svg";
export { ForwardRef as ReactComponent };